module.exports = __webpack_public_path__ + "static/tiktok-new-1d62e18a94bcdb0513bf6a167318999b.png";